import Component from '../abstracts/Component';

export default class ArticleLaunchScrollComponent extends Component {
  get SELECTORS() {
    return {
      media: '[data-ls-media]',
      img: '[data-ls-img]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.media = this.$component.querySelector(this.SELECTORS.media);
    this.img = this.$component.querySelector(this.SELECTORS.img);
  }

  setCenter() {
    let viewHeight = window.innerHeight;
    let mediaHeight = this.media.offsetHeight;
    let headerHeight = document.querySelector('header').offsetHeight;
    let halfViewHeight = (viewHeight - headerHeight) / 2 + headerHeight;
    let position = halfViewHeight - mediaHeight / 2;
    let root = document.documentElement;
    root.style.setProperty('--article-ls-center', `${position}px`);
  }

  setMargin() {
    let mediaHeight = this.media.offsetHeight;
    let imgHeight = this.img.offsetHeight;
    let diff = (mediaHeight - imgHeight) / 2;
    this.img.style.marginBottom = `${diff}px`;
  }

  render() {
    this.log('Rendering...');
    this.setCenter();
    this.setMargin();
  }
}
